<div class="management-content">
    <div class="col-2 screen-selector-background">
        <emm-screen-selector
            [screens]="screens$ | async"
            (screenSelected)="onScreenSelected($event)"
        ></emm-screen-selector>
    </div>
    <div class="right-panes">
        <router-outlet></router-outlet>
    </div>
</div>
